import { post } from '@si/utils';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

import { queryKeys } from './queryKeys';

interface Params {
  projectId: string;
  inviteId: string;
}

export function useResendProjectInvite() {
  const queryClient = useQueryClient();

  const { mutate, error, isPending, isSuccess, reset } = useMutation({
    mutationFn: ({ projectId, inviteId }: Params) =>
      post({
        url: `/projects/${projectId}/team/invites/${inviteId}/resend`,
      }),
    onSuccess: (_, { projectId }) => {
      queryClient.invalidateQueries({
        queryKey: queryKeys.getProjectTeamInvites(projectId),
      });
    },
  });

  const resendProjectInvite = useCallback((params: Params) => mutate(params), [mutate]);

  return {
    resendProjectInvite,
    error,
    isPending,
    isSuccess,
    reset,
  };
}
